import React, { Component } from "react";
import Typography from "@material-ui/core/Typography";
import { withStyles } from "@material-ui/styles";

import "../styles/main.css";

const StyledTitle = withStyles({
  root: {
    fontSize: "20px",
    letterSpacing: 0,
    color: "#4A4547",
    opacity: 1,
    lineHeight: "1.7rem",
    align: "left",
    marginBottom: "16px",
  },
})(Typography);

export class Success extends Component {
  componentDidMount() {
    window.scrollTo(0, 0);
  }

  render() {
    return (
        <div className="main-content-success">
          <div className="wrapper-success" dir="rtl">
            <div className="image-last-page">
              <img
                src={require("../assets/new-logo.svg")}
                alt="logo"
                width="120"
                height="40"
                style={{ display: "block" }}
              />
              <span style={{ display: "block", margin: "5px -6px 2px 0px" }}>
                ככה לומדים היום מהבית
              </span>
            </div>

            <div className="image-success">
              <img
                src={require("../assets/success.svg")}
                alt="logo"
                width="100"
                height="100"
              />
            </div>

            <StyledTitle
              variant="h6"
              display="block"
              className="title-success"
              gutterBottom
              style={{
                textAlign: "center",
                color: "#32C6A9",
                fontSize: "24px",
              }}
            >
              הרישום הסתיים בהצלחה
            </StyledTitle>

            <div className="text-success">
              <p>
              איזה כיף שהצטרפת למרכז הלמידה הוירטואלי לבגרות החורף במתמטיקה של מינהל חינוך ירושלים בשיתוף Class.Me!
                <br />
                אז מה קורה עכשיו?
                <br />מרכז הלמידה הוירטואלי יהיה פתוח עם מתרגל Class.Me ב- LIVE בימים ראשון, שלישי וחמישי, בין השעות: 19:00-21:00
                <br />
                המרכז יפעל 24/7 עם עוד עשרות תלמידים כמוכם שמשתפים שאלות, תשובות ובידע שלהם. 
                <br />
                בזמן התרגול יחכה לכם מתרגל באפליקציה ותינתן לכם האפשרות להעלות שאלות ולדון בתשובות שלהן וכמובן לצפות בשאלות של תלמידים אחרים.
                <br />
                כל המידע שיעלה באפליקציה ישמר כל התקופה לשירותכם.
                <br />
                אל דאגה! כל שאלה עולה כפוסט נפרד ולכן אף שאלה לא מתפספסת (מוזמנים לראות <a
                  href={
                    "https://www.youtube.com/watch?v=00uRxBz115I&feature=youtu.be"
                  }
                  target={"_blank"}
                >
                  {" "}
                  סרטון תפעול האפליקציה{" "}
                </a>).
                <br />
                <b>
                בדקות הקרובות ישלח אליכם SMS עם לינק להורדת האפליקציה - לחצו עליו, הורידו ואתם בפנים!
                </b>
                <br />
                <br />
                מחכים לראותכם/ן,
                <br />
                Class.Me - ככה לומדים היום לבגרות.
                <br />
                <br />
                לכל שאלה ובעיה אנחנו פה-
                <br />
                טלפון: 052-8808558 מייל:{" "}
                <a href={"mailto:contact@class.me"}>contact@class.me</a>
                <br />
                {/* <a href={"tel:052-8808558"}>052-8808558</a> */}
                <br />
                <br />
                אנא קרא את תנאי השימוש שלנו
                <a href={"https://class.me/termsHE.html"}> כאן </a>
                <br />
                <br />
                <p>דברו איתנו גם ב- WhatsApp!</p>
                <a href="https://wa.me/972528808558/?text=%D7%90%D7%94%D7%9C%D7%9F%20%D7%92%D7%9D%20%D7%90%D7%A0%D7%99%20%D7%A0%D7%A8%D7%A9%D7%9E%D7%AA%D7%99%20%D7%9C%D7%9E%D7%A8%D7%9B%D7%96%20%D7%94%D7%9C%D7%9E%D7%99%D7%93%D7%94%20%D7%94%D7%95%D7%99%D7%A8%D7%98%D7%95%D7%90%D7%9C%D7%99%20%D7%A9%D7%9C%20Class.Me%20%D7%91%D7%A9%D7%99%D7%AA%D7%95%D7%A3%20%D7%A2%D7%99%D7%A8%D7%99%D7%99%D7%AA%20%D7%99%D7%A8%D7%95%D7%A9%D7%9C%D7%99%D7%9D%0A%D7%99%D7%A9%20%D7%9C%D7%99%20%D7%A9%D7%90%D7%9C%D7%94%2F%D7%91%D7%A7%D7%A9%D7%94...%20%D7%90%D7%A0%D7%90%20%D7%A6%D7%A8%D7%95%20%D7%A2%D7%99%D7%9E%D7%99%20%D7%A7%D7%A9%D7%A8%20%D7%91%D7%94%D7%A7%D7%93%D7%9D%0A">
                  <button className="share-whatsapp">
                    שלח הודעה
                    <img
                      src={require("../assets/whatsapp-icon.svg")}
                      style={{ marginRight: "20px", verticalAlign: "middle" }}
                      alt="logo"
                    />
                  </button>
                </a>
              </p>
            </div>
            <div className="share-buttons-wrapper">
              <div className="text-success-center">
                <p>שתפו את זה אם תרצו</p>
              </div>

              <div className="share-buttons">
                <a
                  href="https://twitter.com/share?url=https://class.me"
                  onClick="popUp=window.open(this.href, 'popupwindow', 'scrollbars=yes,width=800,height=400');popUp.focus();return false"
                >
                  <button className="share-twitter share-btns">
                    Twitter
                    <img
                      src={require("../assets/twitter-bird.svg")}
                      style={{ marginRight: "20px", verticalAlign: "middle" }}
                      alt="logo"
                    />
                  </button>
                </a>

                <a
                  href="https://www.facebook.com/sharer/sharer.php?u=https://class.me"
                  className="fb-xfbml-parse-ignore"
                >
                  <button className="share-facebook share-btns">
                    Facebook
                    <img
                      src={require("../assets/facebook-f.svg")}
                      style={{ marginRight: "20px", verticalAlign: "middle" }}
                      alt="logo"
                    />
                  </button>
                </a>
              </div>
            </div>
          </div>
        </div>
    );
  }
}

export default Success;
